export const normalizeExamResult = (item) => ({
  id: item.actId || "",
  actId: item.actId || item.id || "",
  clinica: item.clinica || "",
  fecha: item.fechaInforme || item.fecha || "",
  medicoSolicitante: item.medicoSolicitante || "",
  orden: item.numeroOrden || item.orden || "",
  numeroProtocolo: item.numeroProtocolo || "",
})

export const normalizeExamResultsList = (list) =>
  Array.isArray(list) ? list.map(normalizeExamResult) : [];